webpackJsonp([120867015663956],{

/***/ 868:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Tabs = exports.Tab = undefined;
	
	var _extends2 = __webpack_require__(16);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _bind = __webpack_require__(7);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _batching = __webpack_require__(408);
	
	var _batching2 = _interopRequireDefault(_batching);
	
	var _isBlank = __webpack_require__(301);
	
	var _isBlank2 = _interopRequireDefault(_isBlank);
	
	var _styles = {};
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cxStyles = _bind2.default.bind(_styles2.default);
	
	var Tab = function Tab(_ref) {
	  var active = _ref.active,
	      className = _ref.className,
	      id = _ref.id,
	      eventKey = _ref.eventKey,
	      restProps = (0, _objectWithoutProperties3.default)(_ref, ['active', 'className', 'id', 'eventKey']);
	
	  var classNames = (0, _classnames2.default)(className, cxStyles('tabs-panel', { 'is-active': active }));
	
	  return _react2.default.createElement('div', (0, _extends3.default)({}, restProps, {
	    'aria-hidden': !active,
	    'aria-labelledby': (0, _isBlank2.default)(id) ? null : id + 'Label',
	    className: classNames,
	    id: id,
	    role: 'tabpanel'
	  }));
	};
	
	exports.Tab = Tab;
	Tab.propTypes = {
	  active: _propTypes2.default.bool,
	  className: _propTypes2.default.string,
	  id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  eventKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	var TabTitle = function TabTitle(_ref2) {
	  var active = _ref2.active,
	      containerClassName = _ref2.containerClassName,
	      containerStyle = _ref2.containerStyle,
	      eventKey = _ref2.eventKey,
	      onSelect = _ref2.onSelect,
	      tabId = _ref2.tabId,
	      restProps = (0, _objectWithoutProperties3.default)(_ref2, ['active', 'containerClassName', 'containerStyle', 'eventKey', 'onSelect', 'tabId']);
	
	  var classNames = (0, _classnames2.default)(containerClassName, cxStyles('tabs-title', { 'is-active': active }));
	  var onClick = function onClick() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var event = args[0];
	
	
	    event.preventDefault();
	
	    if (onSelect && !(0, _isBlank2.default)(eventKey)) {
	      onSelect.apply(undefined, [eventKey].concat(args));
	    }
	  };
	
	  return _react2.default.createElement(
	    'li',
	    {
	      className: classNames,
	      role: 'presentation',
	      style: containerStyle
	    },
	    _react2.default.createElement('a', (0, _extends3.default)({}, restProps, {
	      'aria-controls': tabId,
	      'aria-selected': active,
	      href: '#' + ((0, _isBlank2.default)(tabId) ? '' : tabId),
	      onClick: onClick,
	      role: 'tab'
	    }))
	  );
	};
	
	TabTitle.propTypes = {
	  active: _propTypes2.default.bool,
	  containerClassName: _propTypes2.default.string,
	  containerStyle: _propTypes2.default.object,
	  eventKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  onSelect: _propTypes2.default.func,
	  tabId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	var TabsHeader = function TabsHeader(_ref3) {
	  var className = _ref3.className,
	      vertical = _ref3.vertical,
	      restProps = (0, _objectWithoutProperties3.default)(_ref3, ['className', 'vertical']);
	
	  var classNames = (0, _classnames2.default)(className, cxStyles('tabs', { vertical: vertical }));
	
	  return _react2.default.createElement('div', (0, _extends3.default)({}, restProps, { className: classNames }));
	};
	
	TabsHeader.propTypes = {
	  className: _propTypes2.default.string,
	  vertical: _propTypes2.default.bool
	};
	
	var TabsContent = function TabsContent(_ref4) {
	  var className = _ref4.className,
	      restProps = (0, _objectWithoutProperties3.default)(_ref4, ['className']);
	
	  var classNames = (0, _classnames2.default)(className, cxStyles('tabs-content'));
	
	  return _react2.default.createElement('div', (0, _extends3.default)({}, restProps, { className: classNames }));
	};
	
	TabsContent.propTypes = {
	  className: _propTypes2.default.string
	};
	
	var TabsControlled = function TabsControlled(_ref5) {
	  var activeKey = _ref5.activeKey,
	      children = _ref5.children,
	      contentClassName = _ref5.contentClassName,
	      contentStyle = _ref5.contentStyle,
	      headerClassName = _ref5.headerClassName,
	      headerStyle = _ref5.headerStyle,
	      onSelect = _ref5.onSelect,
	      vertical = _ref5.vertical,
	      restProps = (0, _objectWithoutProperties3.default)(_ref5, ['activeKey', 'children', 'contentClassName', 'contentStyle', 'headerClassName', 'headerStyle', 'onSelect', 'vertical']);
	
	  var headerChildren = _react.Children.map(children, function (child) {
	    if ((0, _react.isValidElement)(child)) {
	      return _react2.default.createElement(
	        TabTitle,
	        (0, _extends3.default)({}, child.props, {
	          active: child.props.eventKey === activeKey,
	          id: (0, _isBlank2.default)(child.props.id) ? null : child.props.id + 'Title',
	          onSelect: onSelect,
	          tabId: child.props.id
	        }),
	        child.props.title
	      );
	    }
	
	    return null;
	  });
	  var contentChildren = _react.Children.map(children, function (child) {
	    if ((0, _react.isValidElement)(child)) {
	      return (0, _react.cloneElement)(child, { active: activeKey === child.props.eventKey });
	    }
	
	    return child;
	  });
	
	  return _react2.default.createElement(
	    'div',
	    restProps,
	    _react2.default.createElement(
	      TabsHeader,
	      { className: headerClassName, style: headerStyle, vertical: vertical },
	      headerChildren
	    ),
	    _react2.default.createElement(
	      TabsContent,
	      { className: contentClassName, style: contentStyle },
	      contentChildren
	    )
	  );
	};
	
	TabsControlled.propTypes = {
	  activeKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  children: _propTypes2.default.node,
	  contentClassName: _propTypes2.default.string,
	  contentStyle: _propTypes2.default.object,
	  headerClassName: _propTypes2.default.string,
	  headerStyle: _propTypes2.default.object,
	  onSelect: _propTypes2.default.func,
	  vertical: _propTypes2.default.bool
	};
	
	var Tabs = exports.Tabs = (0, _batching2.default)(TabsControlled, { activeKey: 'onSelect' });
	Tabs.displayName = 'Tabs';
	
	Tabs.Tab = Tab;
	
	exports.default = Tabs;

/***/ }),

/***/ 408:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ReactUpdates = __webpack_require__(64);
	
	var _ReactUpdates2 = _interopRequireDefault(_ReactUpdates);
	
	var _createUncontrollable = __webpack_require__(409);
	
	var _createUncontrollable2 = _interopRequireDefault(_createUncontrollable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mixin = {
	  componentWillReceiveProps: function componentWillReceiveProps() {
	    // if the update already happend then don't fire it twice
	    this._needsUpdate = false;
	  }
	};
	
	function set(component, propName, handler, value, args) {
	  component._needsUpdate = true;
	  component._values[propName] = value;
	
	  if (handler) handler.call.apply(handler, [component, value].concat(args));
	
	  _ReactUpdates2.default.batchedUpdates(function () {
	    _ReactUpdates2.default.asap(function () {
	      if (!component.unmounted && component._needsUpdate) {
	        component._needsUpdate = false;
	
	        if (!component.unmounted) component.forceUpdate();
	      }
	    });
	  });
	}
	
	exports.default = (0, _createUncontrollable2.default)(mixin, set);
	module.exports = exports['default'];

/***/ }),

/***/ 409:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createUncontrollable;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(13);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _utils = __webpack_require__(410);
	
	var utils = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function createUncontrollable(mixin, set) {
	
	  return uncontrollable;
	
	  function uncontrollable(Component, controlledValues) {
	    var _class, _temp;
	
	    var methods = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
	    var displayName = Component.displayName || Component.name || 'Component',
	        basePropTypes = utils.getType(Component).propTypes,
	        isCompositeComponent = utils.isReactComponent(Component),
	        controlledProps = Object.keys(controlledValues),
	        propTypes;
	
	    var OMIT_PROPS = ['valueLink', 'checkedLink'].concat(controlledProps.map(utils.defaultKey));
	
	    propTypes = utils.uncontrolledPropTypes(controlledValues, basePropTypes, displayName);
	
	    (0, _invariant2.default)(isCompositeComponent || !methods.length, '[uncontrollable] stateless function components cannot pass through methods ' + 'because they have no associated instances. Check component: ' + displayName + ', ' + 'attempting to pass through methods: ' + methods.join(', '));
	
	    methods = utils.transform(methods, function (obj, method) {
	      obj[method] = function () {
	        var _refs$inner;
	
	        return (_refs$inner = this.refs.inner)[method].apply(_refs$inner, arguments);
	      };
	    }, {});
	
	    var component = (_temp = _class = function (_React$Component) {
	      _inherits(component, _React$Component);
	
	      function component() {
	        _classCallCheck(this, component);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	      }
	
	      component.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return !mixin.shouldComponentUpdate || mixin.shouldComponentUpdate.apply(this, args);
	      };
	
	      component.prototype.componentWillMount = function componentWillMount() {
	        var _this2 = this;
	
	        var props = this.props;
	
	        this._values = {};
	
	        controlledProps.forEach(function (key) {
	          _this2._values[key] = props[utils.defaultKey(key)];
	        });
	      };
	
	      /**
	       * If a prop switches from controlled to Uncontrolled
	       * reset its value to the defaultValue
	       */
	
	
	      component.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        var _this3 = this;
	
	        var props = this.props;
	
	        if (mixin.componentWillReceiveProps) {
	          mixin.componentWillReceiveProps.call(this, nextProps);
	        }
	
	        controlledProps.forEach(function (key) {
	          if (utils.getValue(nextProps, key) === undefined && utils.getValue(props, key) !== undefined) {
	            _this3._values[key] = nextProps[utils.defaultKey(key)];
	          }
	        });
	      };
	
	      component.prototype.componentWillUnmount = function componentWillUnmount() {
	        this.unmounted = true;
	      };
	
	      component.prototype.getControlledInstance = function getControlledInstance() {
	        return this.refs.inner;
	      };
	
	      component.prototype.render = function render() {
	        var _this4 = this;
	
	        var newProps = {},
	            props = omitProps(this.props);
	
	        utils.each(controlledValues, function (handle, propName) {
	          var linkPropName = utils.getLinkName(propName),
	              prop = _this4.props[propName];
	
	          if (linkPropName && !isProp(_this4.props, propName) && isProp(_this4.props, linkPropName)) {
	            prop = _this4.props[linkPropName].value;
	          }
	
	          newProps[propName] = prop !== undefined ? prop : _this4._values[propName];
	
	          newProps[handle] = setAndNotify.bind(_this4, propName);
	        });
	
	        newProps = _extends({}, props, newProps, {
	          ref: isCompositeComponent ? 'inner' : null
	        });
	
	        return _react2.default.createElement(Component, newProps);
	      };
	
	      return component;
	    }(_react2.default.Component), _class.displayName = 'Uncontrolled(' + displayName + ')', _class.propTypes = propTypes, _temp);
	
	    _extends(component.prototype, methods);
	
	    component.ControlledComponent = Component;
	
	    /**
	     * useful when wrapping a Component and you want to control
	     * everything
	     */
	    component.deferControlTo = function (newComponent) {
	      var additions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var nextMethods = arguments[2];
	
	      return uncontrollable(newComponent, _extends({}, controlledValues, additions), nextMethods);
	    };
	
	    return component;
	
	    function setAndNotify(propName, value) {
	      var linkName = utils.getLinkName(propName),
	          handler = this.props[controlledValues[propName]];
	
	      if (linkName && isProp(this.props, linkName) && !handler) {
	        handler = this.props[linkName].requestChange;
	      }
	
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      set(this, propName, handler, value, args);
	    }
	
	    function isProp(props, prop) {
	      return props[prop] !== undefined;
	    }
	
	    function omitProps(props) {
	      var result = {};
	
	      utils.each(props, function (value, key) {
	        if (OMIT_PROPS.indexOf(key) === -1) result[key] = value;
	      });
	
	      return result;
	    }
	  }
	}
	module.exports = exports['default'];

/***/ }),

/***/ 410:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.version = undefined;
	exports.uncontrolledPropTypes = uncontrolledPropTypes;
	exports.getType = getType;
	exports.getValue = getValue;
	exports.getLinkName = getLinkName;
	exports.defaultKey = defaultKey;
	exports.chain = chain;
	exports.transform = transform;
	exports.each = each;
	exports.has = has;
	exports.isReactComponent = isReactComponent;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(13);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function readOnlyPropType(handler, name) {
	  return function (props, propName) {
	    if (props[propName] !== undefined) {
	      if (!props[handler]) {
	        return new Error('You have provided a `' + propName + '` prop to ' + '`' + name + '` without an `' + handler + '` handler. This will render a read-only field. ' + 'If the field should be mutable use `' + defaultKey(propName) + '`. Otherwise, set `' + handler + '`');
	      }
	    }
	  };
	}
	
	function uncontrolledPropTypes(controlledValues, basePropTypes, displayName) {
	  var propTypes = {};
	
	  if (false) {
	    transform(controlledValues, function (obj, handler, prop) {
	      (0, _invariant2.default)(typeof handler === 'string' && handler.trim().length, 'Uncontrollable - [%s]: the prop `%s` needs a valid handler key name in order to make it uncontrollable', displayName, prop);
	
	      obj[prop] = readOnlyPropType(handler, displayName);
	    }, propTypes);
	  }
	
	  return propTypes;
	}
	
	var version = exports.version = _react2.default.version.split('.').map(parseFloat);
	
	function getType(component) {
	  if (version[0] >= 15 || version[0] === 0 && version[1] >= 13) return component;
	
	  return component.type;
	}
	
	function getValue(props, name) {
	  var linkPropName = getLinkName(name);
	
	  if (linkPropName && !isProp(props, name) && isProp(props, linkPropName)) return props[linkPropName].value;
	
	  return props[name];
	}
	
	function isProp(props, prop) {
	  return props[prop] !== undefined;
	}
	
	function getLinkName(name) {
	  return name === 'value' ? 'valueLink' : name === 'checked' ? 'checkedLink' : null;
	}
	
	function defaultKey(key) {
	  return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
	}
	
	function chain(thisArg, a, b) {
	  return function chainedFunction() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    a && a.call.apply(a, [thisArg].concat(args));
	    b && b.call.apply(b, [thisArg].concat(args));
	  };
	}
	
	function transform(obj, cb, seed) {
	  each(obj, cb.bind(null, seed = seed || (Array.isArray(obj) ? [] : {})));
	  return seed;
	}
	
	function each(obj, cb, thisArg) {
	  if (Array.isArray(obj)) return obj.forEach(cb, thisArg);
	
	  for (var key in obj) {
	    if (has(obj, key)) cb.call(thisArg, obj[key], key, obj);
	  }
	}
	
	function has(o, k) {
	  return o ? Object.prototype.hasOwnProperty.call(o, k) : false;
	}
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	function isReactComponent(component) {
	  return !!(component && component.prototype && component.prototype.isReactComponent);
	}

/***/ }),

/***/ 551:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _siteConfig = __webpack_require__(65);
	
	var _siteConfig2 = _interopRequireDefault(_siteConfig);
	
	var _tabs = __webpack_require__(868);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PackageTabs = function (_Component) {
	  _inherits(PackageTabs, _Component);
	
	  function PackageTabs(props) {
	    _classCallCheck(this, PackageTabs);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.handleSelect = _this.handleSelect.bind(_this);
	    _this.state = {
	      activeKey: 1
	    };
	    return _this;
	  }
	
	  PackageTabs.prototype.handleSelect = function handleSelect(activeKey) {
	    this.setState({ activeKey: activeKey });
	  };
	
	  PackageTabs.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      _tabs.Tabs,
	      { defaultActiveKey: 1, headerClassName: 'image-tabs' },
	      _react2.default.createElement(
	        _tabs.Tab,
	        { ref: function ref(n) {
	            return _this2.stag = n;
	          }, containerClassName: 'stag', id: 'stag', eventKey: 1, title: 'Stag & Hen Parties' },
	        _react2.default.createElement(
	          'h3',
	          { className: 'subheader' },
	          'Muddy good fun!'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'For Stag & Hen parties, our off road days are a perfect way to have your last "lads on tour" moments Chuck the Stag in some deep water or treat the Hen to a perfect mud spa. Have a competition to see ',
	          _react2.default.createElement(
	            'strong',
	            null,
	            'who buys the first round that night'
	          ),
	          ' or include some ',
	          _react2.default.createElement(
	            'strong',
	            null,
	            'terrifying forfeits'
	          ),
	          ' for the wimps in the group. Fling mud at targets on our vehicles and see who can do the fastest lap around the section... without getting stuck!'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            'Our 4x4 Stag & Hen parties are tailored to your group, so if you want to throw in a surprise or have something special happen on the day - we encourage it!'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'The course is within easy reach of Bristol, Cardiff and Gloucester; a day of off-roading followed by a night out in some of the UK\'s best Stag & Hen cities is a no-brainer decision.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'From ',
	          _siteConfig2.default.halfDayPrice,
	          ' per person.'
	        )
	      ),
	      _react2.default.createElement(
	        _tabs.Tab,
	        { ref: function ref(n) {
	            return _this2.offRoad = n;
	          }, containerClassName: 'off-road', id: 'off-road', eventKey: 2, title: 'Off Road Training' },
	        _react2.default.createElement(
	          'h3',
	          { className: 'subheader' },
	          'Off road skills when they\'re needed!'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'If you use a 4x4 for your job, or your employees are expected to drive off road when needed, we offer extensive training to give them the ',
	          _react2.default.createElement(
	            'strong',
	            null,
	            'confidence and techniques to perform their job safely'
	          ),
	          '. Our instruction can be 1-on-1 or in a group and lasts a full day\'s training.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            'Our courses include;'
	          )
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            'Introduction to safety aspects of 4x4 and off-road driving.'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Confidently driving through mud and water obstacles.'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Tackling inclines and descending safely.'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Navigating wooded sections.'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Correct assessment of terrain to maintain safety, stability and to prevent roll-overs.'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Basic 4x4 vehicle maintenance.'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            'If you believe you or your employee may encounter special or severe conditions we can include training for this in our courses.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _tabs.Tab,
	        { ref: function ref(n) {
	            return _this2.birthday = n;
	          }, containerClassName: 'birthday', id: 'birthday', eventKey: 3, title: 'Birthday Parties' },
	        _react2.default.createElement(
	          'h3',
	          { className: 'subheader' },
	          'Celebrate in style... or mud!'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            'Our birthday packages are available as group bookings;'
	          ),
	          ' as a full day or a half day. Enjoy a morning of off-roading followed by an afternoon of partying, or celebrate with a full day\'s 4x4ing and a stop for lunch at the local fantastic farm restaurant. We know how important it is that a birthday party is perfect for the birthday boy/girl, so if you have any special arrangements or surprises, let us know!'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Birthdays at our off road school are ',
	          _react2.default.createElement(
	            'strong',
	            null,
	            'perfect for petrol-heads'
	          ),
	          ' of (almost) all ages. Because our course is off the road, we have no restrictions on whether you have a driving license or not. As long as you can reach the pedals and follow instruction sensibly you can have fun with us.'
	        )
	      ),
	      _react2.default.createElement(
	        _tabs.Tab,
	        { ref: function ref(n) {
	            return _this2.tailerMade = n;
	          }, containerClassName: 'tailer-made', id: 'tailer-made', eventKey: 4, title: 'Tailer Made Packages' },
	        _react2.default.createElement(
	          'h3',
	          { className: 'subheader' },
	          ' Off road adventure tailored to you!'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Tailor made packages for any number of people at any skill level.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Combine a day\'s driving with a day\'s Bush Mechanics to make a weekend of it, One-to-one Competitive Safari race-coaching, a session in your new overland-prepared vehicle or a family party day at our course; complete with picnic.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            'If you\'ve got an idea for your perfect 4x4 day, we can make it happen.'
	          )
	        )
	      )
	    );
	  };
	
	  return PackageTabs;
	}(_react.Component);
	
	exports.default = PackageTabs;
	module.exports = exports['default'];

/***/ }),

/***/ 560:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(148);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(80);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _voucherAd = __webpack_require__(154);
	
	var _voucherAd2 = _interopRequireDefault(_voucherAd);
	
	var _packageTabs = __webpack_require__(551);
	
	var _packageTabs2 = _interopRequireDefault(_packageTabs);
	
	var _siteConfig = __webpack_require__(65);
	
	var _siteConfig2 = _interopRequireDefault(_siteConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PackagesPage = function PackagesPage() {
	  return _react2.default.createElement(
	    'span',
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: _siteConfig2.default.siteName + ' | Packages | ' + _siteConfig2.default.siteTitleAlt,
	      meta: [{
	        name: 'description',
	        content: 'Book your 4x4 experience day for corporate events with your work colleagues, Stag & Hen Parties or even "Stens", birthday parties or tailor-made events. Based in Cardiff South Wales with specially designed 4x4 off roading courses.'
	      }]
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: 'packages banner' },
	      _react2.default.createElement(
	        'div',
	        { className: 'banner-info top-off-center text-center' },
	        _react2.default.createElement(
	          'h2',
	          { className: 'uppercase' },
	          'A true 4x4 Driving day with the Experts.'
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'spacer white hide-for-small-only' },
	          '\u2015'
	        ),
	        _react2.default.createElement(
	          'h5',
	          { className: 'hide-for-small-only' },
	          'Packages from \xA3100 per person'
	        ),
	        _react2.default.createElement(
	          'a',
	          { className: 'button secondary uppercase large hide-for-small-only', href: '/bookings' },
	          'Bookings'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'main',
	      null,
	      _react2.default.createElement(
	        'section',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'small-12 medium-10 columns' },
	          _react2.default.createElement(
	            'div',
	            { className: 'content-header' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'uppercase' },
	              'Packages'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'large-9 columns' },
	          _react2.default.createElement(
	            'div',
	            { className: 'content-body' },
	            _react2.default.createElement(_packageTabs2.default, null)
	          )
	        ),
	        _react2.default.createElement(
	          'aside',
	          { className: 'large-3 columns' },
	          _react2.default.createElement(
	            'div',
	            { className: 'content-body' },
	            _react2.default.createElement(_voucherAd2.default, null)
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = PackagesPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-packages-js-3ba8e10a7e5eb11972bd.js